/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs */

const en_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience!`)
};

const ar_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const de_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const es_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const fr_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const it_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const ja_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const ko_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const pt_br_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const ru_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const th_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const tr_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience.`)
};

const zh_cn_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`现在就去享受 Plus 独享树种、3 倍专注金币，以及无广告的专属特权！`)
};

const zh_tw_onboarding_paywall_subscribed_success_content_trial_cna = /** @type {(inputs: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`现在就去享受 Plus 独享树种、3 倍专注金币，以及无广告的专属特权！`)
};

/**
* | output |
* | --- |
* | "Enjoy exclusive Plus trees, 3× Focus Coins, and an ad-free experience!" |
*
* @param {Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_subscribed_success_content_trial_cna = /** @type {((inputs?: Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Subscribed_Success_Content_Trial_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "ar") return ar_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "de") return de_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "es") return es_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "fr") return fr_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "it") return it_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "ja") return ja_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "ko") return ko_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "ru") return ru_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "th") return th_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "tr") return tr_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
	return zh_tw_onboarding_paywall_subscribed_success_content_trial_cna(inputs)
});